import UXWechatIcon from '@ux/icon/wechat';
import '@ux/icon/wechat/styles';

import IconProps from './IconProps';

export default function WechatIcon(props: IconProps) {
  return <UXWechatIcon {...props} />;
}
